// @core/api/endpoints/landing/archive_landing_page.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ArchiveLandingPageRequest,
  LandingPageResponse,
} from '../../../types/landing';

const BASE_PATH = '/landing';

/**
 * Archive landing page
 * Archives a page. Archived pages are no longer publicly accessible.
 */
export async function ArchiveLandingPage(
  page_id: string,
  data: ArchiveLandingPageRequest,
  options?: RequestOptions
): Promise<LandingPageResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/landing/pages/:page_id/archive`;
  requestPath = requestPath.replace(':page_id', encodeURIComponent(page_id));
  const requestOptions = options;
  return client.post<LandingPageResponse>(requestPath, data, requestOptions);
}
